import useAuth from "../../routes/login/AuthContext";

import { useNetwork } from "../../hooks/useNetwork";
import { UpdateNetwork } from "../../services/NetworkApi";
import { useNetworkContext } from "../../contexts/NetworkContext/context";

export const useNetworkImportType = () => {
  const { getAuthToken } = useAuth();
  const { updateNetworkValues } = useNetworkContext();
  const { selectedNetwork } = useNetwork();

  const handleImportTypeChange = async (importType: string) => {
    await UpdateNetwork(
      selectedNetwork.l1Id,
      { networkName: selectedNetwork.l1Name, importType },
      await getAuthToken()
    );
    return updateNetworkValues(selectedNetwork.l1Id, {
      importType,
    });
  };

  return {
    handleImportTypeChange,
    importType: selectedNetwork.importType,
  };
};
